const lang = {
    ja: {
        'adminSettingShoppingCart.credit': 'クレジット',
        'adminSettingShoppingCart.card': '銀行口座',
    },
};

export default lang;
